import React from 'react';
import axios from 'axios';
import { Link, withRouter } from 'react-router-dom';
import Pagination from '../../component/Pagination';
import InvoiceStatus from '../../component/InvoiceStatus';
import AlertLabel from '../../component/AlertLabel';
import { Field, reduxForm } from 'redux-form';
import { RenderDatePicker, RenderSearchForm } from '../../component/formInput';
import moment from 'moment';
import InvoiceStatusSelect from '../../component/InvoiceStatusSelect';
import { StringUtils } from '../../utils/javascriptUtils';
import PaymentTypeSelect from '../../component/PaymentTypeSelect';
import { connect } from 'react-redux';
import BlockUI from '../../component/BlockUI';
import { toast, ToastContainer } from 'react-toastify';
import { InvoicePageRole } from '../../component/UserPermission';

var numeral = require('numeral');
var _ = require('lodash');

function InvoiceDatePicker(from_date, to_date, onDateChange, clearDataFilter, user_role) {
 
  return ( 
    <div style={{float: "right"}}>
      <div style={{display: 'inline-flex', marginRight:10 }}>
        <span className="input-group-text" style={{height:'fit-content'}}>
          <i style={{ height:20 }} className="icon-calendar22"></i>
        </span>
        <Field
          name="from_date"
          placeholder="dd/mm/yyyy"
          dateFormat="dd/MM/yyyy"
          defaultValue={from_date}
          disabled={user_role !== "MASTER"}
          onChangeAction={(value)=>onDateChange(value, to_date)}
          component={RenderDatePicker}
          />
      </div>
      <div style={{display: 'inline-flex', marginRight:10 }}>
        <span className="input-group-text" style={{height:'fit-content'}}>
          <i style={{ height: 20 }} className="icon-calendar22"></i>
        </span>
        <Field
          name="to_date"
          placeholder="dd/mm/yyyy"
          dateFormat="dd/MM/yyyy"
          defaultValue={to_date}
          disabled={user_role !== "MASTER"}
          onChangeAction={(value)=>onDateChange(from_date, value)}
          component={RenderDatePicker}/>
      </div>
      {user_role === "MASTER" && <div style={{display: 'inline-flex',height:'fit-content'}}>
        <button onClick={()=> clearDataFilter()} style={{whiteSpace:'nowrap', width:'inherit'}} className="btn btn-warning">x</button>
      </div>}
    </div>
  )
}

function InvoiceRows(userProfile, role_path, invoice_data, handleCancelInvoice) {
    const inner_invoice_rows = _.map(invoice_data,(invoice, key) => {
      return (
        <tr key={key}>
          <td>
            <Link to={role_path + "/invoice/detail/"+invoice.id}>{invoice.code}</Link>
            <br/>
            {userProfile && InvoicePageRole.isShowAgencyInvoice(userProfile.role) && invoice.agency_invoice && <Link to={role_path + "/invoice/agency/detail/"+invoice.agency_invoice.id}>{invoice.agency_invoice.code}</Link>}
          </td>
          <td>
            <Link to={"#"}>{invoice.user.email}</Link>
            <br/>
            {invoice.user.agency && !invoice.user.agency.has_custom_brand && <small className="text-muted"> <strong>Đại lý:</strong> {invoice.user.agency.agency_admin.email}</small>}
            {invoice.user.agency && invoice.user.agency.has_custom_brand && <small className="text-muted"> <strong>Thương hiệu riêng:</strong> {invoice.user.agency.agency_admin.email}</small>}
            {!invoice.user.agency && <small className="text-muted"> <strong>Khách lẻ</strong> </small>}
          </td>	
          <td>
            {invoice.sale ? invoice.sale.email : "N/A"}
            <br/>
            <small>{invoice.sale && invoice.sale.full_name}</small>
          </td>	
          <td>
            {invoice.payment_type}
          </td>
          <td>
            {InvoiceStatus(invoice.invoice_status, invoice.payment_date)}
          </td>
          <td>
            {invoice.created_date}
          </td>
          {userProfile && InvoicePageRole.isShowInvoiceMoney(userProfile.role) && <td>
            {numeral(invoice.total).format('0,0')}
          </td>}
          <td>
            <div className="icons-list">
              <div className="dropdown">
                <a href="#" className="list-icons-item" data-toggle="dropdown">
                  <i className="icon-menu9"></i>
                </a>
                <div className="dropdown-menu dropdown-menu-right">
                  <Link to={role_path + "/invoice/detail/"+invoice.id} className="dropdown-item">
                    <i className="icon-list-numbered"></i> Chi tiết
                  </Link>
                  {userProfile && InvoicePageRole.isShowHistory(userProfile.role) && <Link to={role_path + "/invoice/history/"+invoice.id} className="dropdown-item">
                    <i className="icon-history"></i> Lịch Sử Tương Tác
                  </Link>}
                  {invoice.invoice_status == "NEW" && InvoicePageRole.isCancelInvoice(userProfile.role) && <a to={"#"} onClick={()=> handleCancelInvoice(invoice.id)} className="dropdown-item">
                    <i className="icon-cross2"></i> Huỷ Đơn Hàng
                  </a>}
                </div>
              </div>
            </div>
          </td>
        </tr>
      )
    })
  return inner_invoice_rows;
}

class InvoiceTable extends React.Component {
  constructor(props) {
    super(props);
    const {invoiceStatus, paymentMethod} = this.props.routeProps.match.params;
    this.state = {
      isLoading: false,
      table_data: [],
      table_query: {
        current_page: 1,
        number_of_row: 20,
        invoice_status: invoiceStatus,
        payment_type: paymentMethod,
        sort_by: "",
        sort_asc: false,
        search_field: "search",
        search_value: "",
        alert_label: null,
        from_date: this.props.userProfile.role === "SALE" ? moment().startOf('month') : null,
        to_date: this.props.userProfile.role === "SALE" ? moment().endOf('month') : null
      },
      invoice_static: null
    }
  }

  componentDidMount() {
    this.listReload(this.state.table_query);
    this.staicReload(this.state.table_query)
  }

  // Tải và cập nhật số lượng theo loại đơn hàng.
  staicReload(table_query) {
    const {userProfile} = this.props;
    const self = this;
    if(userProfile && InvoicePageRole.isShowInvoiceMoney(userProfile.role)) {
      return axios({
        method: 'post',
        url: window.api_url + '/admin/api/invoice/static',
        withCredentials: true,
        data: {
          from_date: table_query.from_date,
          to_date: table_query.to_date,
          payment_type: table_query.payment_type
        }
      }).then(function (response) {
        if(!response.data.isError) {
          self.setState({
            ...self.state,
            invoice_static: response.data.data
          })
        }
      });
    }
  }

  gotoPage = (page) => {
    const table_query = {
      ...this.state.table_query,
      current_page: page
    };
    this.listReload(table_query);
  }
  
  listReload = (table_query) => {
    const self = this;
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/invoice/list',
      withCredentials: true,
      data: table_query
    }).then(function (response) {
      self.setState({
        ...self.state,
        table_query: table_query,
        table_data: response.data.data
      })
    });
  }
  
  handleCancelInvoice = (invoice_id) => {
    const self = this;
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/invoice_cancel',
      withCredentials: true,
      data: {
        invoice_id: invoice_id
      }
    }).then(function (response) {
      if(!response.data.isError) {
        self.setState({
          alert_label: {status: "SUCCESS", message: "Hủy đơn hàng thành công."}
        })
        self.listReload(self.state.table_query);
      } else {
        self.setState({
          alert_label: {status: "ERROR", message: "Hủy đơn hàng thất bạinvoice."}
        })
      }
    });
  }

  onInvoiceStatusChange = (invoice_status) => {
    const { history, role_path } = this.props;
    const table_query = {
      ...this.state.table_query,
      invoice_status: invoice_status
    };
    // listReload after setState
    this.setState({
      table_query: table_query
    }, () => this.listReload(table_query))
    history.push(role_path + "/invoice/"+ invoice_status + "/payment-method/" + table_query.payment_type)
  }

  onPaymentTypeSelect = (payment_type) => {
    const { history, role_path } = this.props;
    const table_query = {
      ...this.state.table_query,
      payment_type: payment_type
    };
    // listReload after setState
    this.listReload(table_query);
    this.staicReload(table_query);
    // TODO add payment_type to url
    history.push(role_path + "/invoice/"+ table_query.invoice_status + "/payment-method/" + payment_type)

  }

  onSearchSubmit = (values) => {
    const search_value = values.search ? values.search : "";
    const { history } = this.props;
    const table_query = {
      ...this.state.table_query,
      search_value: search_value,
      current_page: 1,
      invoice_status: "all",
      from_date: null,
      to_date: null

    };
    history.push("?search=" + search_value);
    this.listReload(table_query);
  }

  onDateChange = (from_date, to_date) => {
    const table_query = {
      ...this.state.table_query,
      search_value: "",
      current_page: 1,
      from_date: moment(from_date).format("YYYY-MM-DD 00:00:00"),
      to_date: moment(to_date).format("YYYY-MM-DD 23:59:59")
    };
    this.setState({
      ...this.state,
      table_query: table_query
    });

    if(from_date && to_date) {
      this.listReload(table_query);
      this.staicReload(table_query);
    }
  }

  clearDataFilter = () => {
    const { reset } = this.props;
    const table_query = {
      ...this.state.table_query,
      search_value: "",
      current_page: 1,
      from_date: null,
      to_date: null
    };
    this.setState({
      ...this.state,
      table_query: table_query
    });
    reset();
    this.listReload(table_query);
    this.staicReload(table_query);
  }
  
  onKeyPess = (key_code) => {
    const { history, role_path } = this.props;
    if (key_code == "Escape") {
      history.push(role_path + "/invoice/all/payment-method/all")
      this.clearDataFilter();
    }
  }

  // Xuất file excel
  exportExcel = () => {
    const { table_query } = this.state;
    const self = this;
    this.setState({
      isLoading: true
    })
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/invoice/export',
      withCredentials: true,
      data: {
        table_query: table_query
      }
    }).then(function (response) {
      self.setState({
        isLoading: false
      })
      if(!response.data.isError) {
        toast.success("Xuất File Thành Công !")
      }
    });
  }

  render() {
    const { handleSubmit, userProfile, role_path } = this.props;
    const {table_query, table_data, alert_label, invoice_static, isLoading} = this.state;
    const start_date_of_current_month = moment().startOf('month');
    const end_date_of_current_month = moment().endOf('month');

    const start_date_of_previous_month = moment().subtract(1,'months').startOf('month');
    const end_date_of_previous_month = moment().subtract(1,'months').endOf('month');

    return(
      <React.Fragment> 
        {isLoading && <BlockUI />}
        <ToastContainer />
        <div className="page-header">
          <h4>
            <i className="icon-paragraph-justify2"></i>
            <span className="text-semibold"> Danh sách đơn hàng</span>
          </h4>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-body">
              <form style={{display:"inline-flex"}} onSubmit={handleSubmit(this.onSearchSubmit)}>
                <div style={{ width:"100%", paddingRight:5}}>
                  <Field
                    name="search"
                    placeholder="Mã đơn hàng - Email khách hàng"
                    defaultValue = {table_query.search_value}
                    onKeyAction={(ev)=> this.onKeyPess(ev)}
                    component={RenderSearchForm}
                  />
                </div>
              </form>
              {StringUtils.isEmptyOrSpaces(table_query.search_value) && invoice_static && <div className="row">
                <div className="col-md-6">
                  <InvoiceStatusSelect invoice_static={invoice_static} onInvoiceStatusChange={this.onInvoiceStatusChange} />
                </div>
                <div className="col-md-6">
                  {InvoiceDatePicker(table_query.from_date, table_query.to_date, this.onDateChange, this.clearDataFilter, userProfile.role)}
                  <center>
                    <div style={{display: 'inline-flex', marginRight:10 }}>
                      <button onClick={() => this.onDateChange(start_date_of_previous_month, end_date_of_previous_month)} className="badge badge-secondary" style={{marginRight: 10 }}> Tháng Trước </button>
                      <button onClick={() => this.onDateChange(start_date_of_current_month, end_date_of_current_month)} className="badge badge-success"> Tháng Hiện Tại </button>
                    </div>
                  </center>
                </div>
                <br/>
                {/* <div className="col-md-12">
                  <button onClick={() => this.exportExcel} type="button" className="bg-success btn" style={{float: "right"}}>
                    <i className="icon-file-excel"></i> Xuất File
                  </button>
                </div> */}
              </div>}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {alert_label && <AlertLabel status = {alert_label.status} message = {alert_label.message}/>}
            <div className="card">
              <div style={{margin:10}} className="text-align-right">
                <PaymentTypeSelect payment_type_selected={table_query.payment_type} onPaymentTypeSelect={this.onPaymentTypeSelect}/>
              </div>
              <div className="table-responsive">
                <table className="table table-togglable table-hover default footable-loaded footable">
                  <thead>
                    <tr>
                      <th>Mã Đơn Hàng</th>
                      <th>Khách Hàng</th>
                      <th>Sale man</th>
                      <th>Phương Thức TT</th>
                      <th style={{width: "130px"}}>Trạng Thái</th>
                      <th>Ngày Đăng Ký</th>
                      {InvoicePageRole.isShowInvoiceMoney(userProfile.role) && <th>Tổng Tiền</th>}
                      <th className="text-center footable-visible footable-last-column" style={{width: "30px"}}>
                        <i className="icon-menu-open2"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {table_data.data && InvoiceRows(userProfile, role_path, table_data.data, this.handleCancelInvoice)}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination query={table_query} data={table_data} handle={this.gotoPage}/>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapState = state => ({
  userProfile: state.userProfile.data,
  role_path: state.userProfile.role_path,
});

const mapDispatch = (dispatch) => ({

});

const InvoiceTableWrapper = reduxForm({
  form: 'InvoiceTable',
  destroyOnUnmount: true,
  enableReinitialize: true,
})(InvoiceTable);

export default connect(mapState, mapDispatch)(withRouter(InvoiceTableWrapper));